import { makeAutoObservable, runInAction } from 'mobx';

import {cmApi } from '@src/api';
import { preloaderStore } from '@stores/preloaderStore';
import type { CmApi, OrganizationDto } from '@src/api';

import { organizationsStore } from '../organizationsStore';

class OrganizationCardStore {
  organization: OrganizationDto | null = null;

  isNew = false;

  editMode = false;

  disableDelete = false;

  disableEdit = false;

  hiddenEdit = false;

  hiddenDelete = false;

  hiddenClean = false;

  hiddenSave = false;

  api: CmApi;

  constructor({ api }: { api: CmApi }) {
    this.api = api;
    makeAutoObservable(this);
  }

  get isEditMode() {
    return this.editMode || this.isNew;
  }

  setNew = (isNew = true) => {
    this.isNew = isNew;
    this.organization = null;
  };

  setDisableDelete = (disableDelete = true) => {
    this.disableDelete = disableDelete;
  };

  setHiddenEdit = (hiddenEdit = true): void => {
    this.hiddenEdit = hiddenEdit;
  };

  setHiddenDelete = (hiddenDelete = true): void => {
    this.hiddenDelete = hiddenDelete;
  };

  setHiddenClean = (hiddenClean = true): void => {
    this.hiddenClean = hiddenClean;
  };

  setHiddenSave = (hiddenSave = true): void => {
    this.hiddenSave = hiddenSave;
  };

  setEditMode = (editMode = true) => {
    this.editMode = editMode;
  };

  setIsChanged = () => {
    organizationsStore.setIsChanged();
  };

  save = async (organization: OrganizationDto) => {
    preloaderStore.preloader(true);
    try {
      if (this.isNew) {
        const { data, error } = await this.api.organizations.addOrganization(organization);
        if (error) throw new Error();
        if (data?.code) {
          this.organization = data;
          this.editMode = false;
          this.isNew = false;
        }
        preloaderStore.preloader(false);
        this.setIsChanged();
        return data;
      }
      const { data, error } = await this.api.organizations.updateOrganization(organization);
      if (error) throw new Error();
      if (data?.code) {
        this.organization = data;
        this.editMode = false;
        this.setIsChanged();
      }
      preloaderStore.preloader(false);
      return data;
    } catch (err) {
      preloaderStore.preloader(false);
      throw new Error();
    }
  };

  delete = async (code?: string) => {
    preloaderStore.preloader(true);
    // Удаление на странице списка организаций
    if (code) {
      await this.api.organizations.deleteOrganization(code);
      preloaderStore.preloader(false);
      this.setIsChanged();
      return;
    }

    // Удаление на странице карточки организации
    if (this.organization?.code) {
      await this.api.organizations.deleteOrganization(this.organization.code);
      this.setIsChanged();
    }
    preloaderStore.preloader(false);
  };

  fetch = async (code?: string): Promise<void> => {
    if (!code) {
      return;
    }
    preloaderStore.preloader(true);

    this.setEditMode(false);
    this.setNew(false);

    const { data } = await this.api.organizations.getOrganization(code);
    if (data) {
      runInAction(() => {
        this.organization = data;
      });
    }

    preloaderStore.preloader(false);
  };
}

export const organizationCardStore = new OrganizationCardStore({
  api: cmApi,
});
